import React, { useEffect, useState } from 'react';
import { StyledImage, StyledWrapper } from './style';
// import photoCall from '../../../../assets/images/png/PHOTOCALL_LIDERAZGO.png';
import { API_SOCIAL } from '../../../constants/api';
import request from '../../../utils/api';

const ZeroWaste = () => {
  const [image, setImage] = useState();
  useEffect(() => {
    request(`${API_SOCIAL}widget/home`, {
      params: '',
      method: 'GET'
    }).then(response => {
      response.map(el => {
        if (el.type === 'zerowaste') {
          setImage(el.icon);
        }
        return image;
      });
    });
  }, []);
  return (
    <StyledWrapper>
      <StyledImage src={image} />
    </StyledWrapper>
  );
};

export default ZeroWaste;
